var Marionette = require('backbone.marionette');
var CommonUtils = require('../../utils/common-utils.js');
var Dicts = require('../../data/dicts');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');

var VitalsForm = Marionette.View.extend({
    template: require('../../templates/medicals/patient-vitals-form.html'),
    ui: {
        formModal: '#vital-form-modal',
        save: '#save',
        time: '#time',
        status: '#status',
        pbStatus: "#pbStatus",
        pbTime: "#pbTime",
        pbValueType: "#pbValueType",
        pbValue: "#pbValue",
        pbValueUnit: "#pbValueUnit",

        leftSide: '.inputs'
    },

    events: {
        'click @ui.save': 'saveVital',
        'keyup input[required]': 'validate',
        'change input[required]': 'validate'
    },

    templateContext: function () {
        var that = this;
        return {
            title: that.mode == 'add' ? 'Add vital' : 'Edit vital',
            mode: that.mode,
            status: that.status,
            time: (that.vital.time == '' || that.vital.time == null || that.vital.time == 0
                ? '' : that.utils.longToDateTimeFormatted(Number(that.vital.time), 'MM/DD/YYYY hh:mm A'))/*,

            pbStatus: that.pbStatus,
            pbTime: (that.vital.pbTime == '' || that.vital.pbTime == null || that.vital.pbTime == 0
                ? '' : that.utils.longToDateTimeFormatted(Number(that.vital.pbTime), 'MM/DD/YYYY hh:mm A')),
            pbValueType: that.pbTime,
            pbValue: that.pbValue,
            pbValueUnit: that.pbValueUnit*/
        };
    },

    initialize: function (options) {
        _.bindAll(this, 'onRender', 'showModal', 'hideModal', 'saveVital',
            'fillVital', 'validate', 'search', 'renderResultInTable',
            'fillFormFromSelectedResult', 'showLoading', 'hideLoading');
        if (options) {
            this.mode = options.mode;
            this.vital = options.vital;
        }
        this.utils = new CommonUtils();
    },

    onRender: function () {

        this.showModal();
        /*this.ui.searchResultsTable.hide();
        this.ui.save.attr('disabled', true);*/

        this.ui.time.datetimepicker({
            showClear: true,
            showClose: true,
            useCurrent: false,
            format: 'MM/DD/YYYY hh:mm A'
        });

        /*this.ui.time.on("dp.change", function (e) {
            if (e.date) {
                this.parameters.time = e.date.valueOf();
            } else {
                this.parameters.time = 0;
            }
        }).on('dp.show', function () {
            return $(this).data('DateTimePicker').defaultDate(this.utils.getDateWithoutTime(new Date()));
        });*/

        if (this.mode == 'edit') {
            this.ui.leftSide.removeClass('col-md-6');
            this.ui.leftSide.addClass('col-md-11');
        }
        this.validate();

    },

    showModal: function () {
        this.ui.formModal.modal("show");
    },

    hideModal: function () {
        this.ui.formModal.modal("hide");
    },

    saveVital: function () {
        if (this.mode == 'add')
            this.triggerMethod('new:vital', this.fillVital());
        else if (this.mode == 'edit')
            this.triggerMethod('update:vital', this.fillVital());
        this.hideModal();
    },

    fillVital: function () {
        this.vital.time = this.utils.dateToLong(this.ui.time.val());
        this.vital.status = this.utils.status;
        this.vital.time = this.utils.dateToLong(this.ui.time.val());
        return this.vital;
    },

    validate: function () {
    },

    search: function (event) {},

    renderResultInTable: function (results) {
        var that = this;

        results.forEach(function (item) {
            var newRowContent = "<tr class='clickable' id='" + item.code + "'><td>"
                + item.code + "</td><td>" + item.name + "</td></tr>";
            $('#search-results tbody').append(newRowContent);
        });

        $("#search-results tr:not(:first)").on('click', function (event) {
            var id = event.currentTarget.id;
            $(this).addClass('selected').siblings().removeClass('selected');
            that.fillFormFromSelectedResult(id, results);
        });
        if (results.length > 0) {
            this.ui.searchResultsTable.show();
        }
    },

    fillFormFromSelectedResult: function (selectedId, results) {
        var selected = _.findWhere(results, {code: selectedId});
        this.vital.vitalId = selected.code;
        this.vital.time = selected.time;
        this.ui.icdCode.val(selected.code);
        this.ui.time.val(selected.time);
        this.validate();
    },

    showLoading: function () {
        this.utils.showSpinner('#vital-loader');
    },

    hideLoading: function () {
        this.utils.hideSpinner('#vital-loader');
    }

});

module.exports = VitalsForm;


//////////////////
// WEBPACK FOOTER
// ./app/views/medicals/patient-vitals-form.js
// module id = 382
// module chunks = 0